// Категории продуктов с backend (products.category) → отделы магазина для группировки списка.
export type ProductCategory = 'dairy' | 'meat' | 'vegetables' | 'grains' | 'other';

// Порядок = удобство обхода магазина; «Прочее» в конце.
export const DEPARTMENTS: Array<{ key: ProductCategory; label: string }> = [
  { key: 'vegetables', label: 'Овощи и фрукты' },
  { key: 'meat', label: 'Мясо и рыба' },
  { key: 'dairy', label: 'Молочное' },
  { key: 'grains', label: 'Бакалея и крупы' },
  { key: 'other', label: 'Прочее' },
];

export function departmentLabel(key: ProductCategory): string {
  return DEPARTMENTS.find((d) => d.key === key)?.label ?? 'Прочее';
}
